export const FIELDS_ICON_MAPPER = {
    text:'fa-text-height',
    number: 'fa-hashtag',
    date: 'fa-calendar-days',
    dropdown: 'fa-square-caret-down',
    checkbox:'fa-square-check',
    radio:'fa-circle-dot'
}